export default {"src":"/_next/static/media/crafted2smile.7d566c25.svg","height":252,"width":413,"blurWidth":0,"blurHeight":0};